module.exports = __webpack_public_path__ + "static/media/Yara Greyjoy.d96847c4.jpg";